export const file_to_keys = {
  sunpharma_paonta_sahib: {
    recipe: {
      required: [
        "Product Name",
        "Spec ID",
        "STP ID",
        "Test ID",
        // "Fixed time taken for one batch",
        // "Additional time per batch",
        "Analyst Group",
        "Clubbing Group",
        // "Machine Required",
        // "Analyst Required",
        // "Same Analyst"
      ], optional: [
        "Num max batches",
        "Step ID", "Step Name",
        "Sequence",
      ]
    },
    transactional_data: {
      required: [
        "Product Code",
        "Sample Type",
        "Batch No",
        "Lot Creation Date",
        "QC Receive Date",
        "Spec ID",
      ],
      optional: [
        "Insp Lot No",
        "Market",
      ]
    },
    test_types_and_machine: {
      required: [
        // "Campaign Group Name / Combined Test Configuration"
        "Test ID"
      ],
      optional: []
    },
    test_types_and_analyst: {
      required: [
        // "Campaign Group Name / Combined Test Configuration"
        "Test ID"
      ],
      optional: []
    },
    analyst_availability: {
      required: [
        "Analyst Name", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday", "Analysts Code"
      ],
      optional: []
    },
    test_configuration: { // this is test description itself.
      required: [
        // "Campaign Group Name / Combined Test Configuration",
        "Test ID",
        "Num max batches",
        "Test Type",
        "Machine Required",
        "Machine Abbrevation"
      ],
      optional: [
        "Instruments Used"
      ]
    },
    machine_calibration_schedule: {
      required: [
        "Machine ID",
        "Frequency",
        "Due Dates",
        "Time required for calibration (hrs)"
      ],
      optional: []
    },
    sla_data: {
      required: [
        "sample_type",
        "SLA",
      ],
      optional: [
        "Material Type",
      ]
    },
  }
};